import { getDocsTrackingMarkerDestination } from '@realadvisor/transform/docs-tracking-marker';
import { replaceHtmlHrefs } from '@realadvisor/transform/html-href';

import { escapeAttr } from './draftConvertCore';

export const resolveDocsTrackingMarkersForPreview = (
  html: string,
  allowLocal: boolean,
): string =>
  replaceHtmlHrefs(html, ({ match, prefix, href }) => {
    const destination = getDocsTrackingMarkerDestination(
      href.replaceAll('&amp;', '&'),
      allowLocal,
    );
    return destination == null
      ? match
      : `${prefix}"${escapeAttr(destination)}"`;
  });
